export const user = (state) => {
  return state.user;
};
export const baseUrl = (state) => {
    return state.baseUrl;
};




// WEBPACK FOOTER //
// ./src/store/getters.js